import React, { useEffect, useState } from "react";
import { Flex, IconButton, Input } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "../../../../../../../store";
import { SmallAddIcon } from "@chakra-ui/icons";
import {
  TalesEvent,
  TalesEventDetail,
  TalesProgramma,
} from "../../../../../../../utils/types/TalesProgramma";
import { editProgramma } from "../../../../../../../store/programma/actions/edit";

interface Props {
  evento: TalesEvent;
  programma: TalesProgramma;
}
export default function NewEventDetailForm({ evento, programma }: Props) {
  const [newEventoDetail, setNewEventoDetail] = useState<TalesEventDetail>({
    description: "",
    ora: "",
    show: true,
  });
  useEffect(() => {}, [newEventoDetail]);

  const dispatch = useDispatch<AppThunkDispatch>();

  const handleSubmit = (e: React.MouseEvent<HTMLElement>) => {
    if (newEventoDetail.ora !== "" || newEventoDetail.description !== "") {
      let newProgramma;

      const eventIndex = programma.events.indexOf(evento);
      let newDetails = [...evento.details, newEventoDetail];
      newDetails.sort((a, b) => a.ora.localeCompare(b.ora));
      let newEvent: TalesEvent = {
        title: evento.title,
        show: evento.show,
        details: newDetails,
      };

      let newEvents = [...programma.events];
      newEvents[eventIndex] = newEvent;
      newProgramma = { ...programma, events: newEvents };

      dispatch(editProgramma(newProgramma));
    }

    setNewEventoDetail({ description: "", ora: "", show: true });
  };

  return (
    <Flex my="10px">
      <Input
        id="ora"
        type="text"
        placeholder="Ore *"
        onChange={(val) =>
          setNewEventoDetail({ ...newEventoDetail, ora: val.target.value })
        }
        value={newEventoDetail.ora}
        mr="10px"
      />
      <Input
        id="description"
        type="text"
        placeholder="Descrizione *"
        onChange={(val) =>
          setNewEventoDetail({
            ...newEventoDetail,
            description: val.target.value,
          })
        }
        value={newEventoDetail.description}
        mr="10px"
      />
      <IconButton
        isRound={true}
        aria-label="Aggiungi"
        variant="solid"
        isDisabled={
          newEventoDetail.ora === "" || newEventoDetail.description === ""
        }
        icon={<SmallAddIcon />}
        colorScheme="green"
        onClick={handleSubmit}
      />
    </Flex>
  );
}
